import React, { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import Navbar from '../components/Navbar';

export default function HallOfFame() {
  const [topPlayers, setTopPlayers] = useState([]);
  const [topLeaderboard, setTopLeaderboard] = useState([]);

  useEffect(() => {
    const fetchTopPlayers = async () => {
      const ref = doc(db, 'highlights', 'topPlayers');
      const snap = await getDoc(ref);
      if (snap.exists()) {
        setTopPlayers(snap.data().players || []);
      }
    };

    const fetchTopLeaderboard = async () => {
      const ref = doc(db, 'highlights', 'topLeaderboard');
      const snap = await getDoc(ref);
      if (snap.exists()) {
        setTopLeaderboard(snap.data().players || []);
      }
    };

    fetchTopPlayers();
    fetchTopLeaderboard();
  }, []);

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-yellow-50 px-6 py-10">
        <h1 className="text-4xl font-bold text-center text-purple-800 mb-6">🌟 Hall of Honour 🌟</h1>
        <p className="text-2xl font-bold text-center text-purple-800 mb-6">Recognizing our top Brainy Buddies</p>

        {/* 🧠 Top 3 by Chronos */}
        <div className="max-w-3xl mx-auto space-y-6 mb-12">
          <h2 className="text-2xl font-bold text-purple-700 mb-4 text-center">🧠 Top 3 by Chronos 🧠</h2>
          {topPlayers.length === 0 ? (
            <p className="text-center text-gray-500">No chronos data yet. Stay tuned!</p>
          ) : (
            topPlayers.map((player, index) => (
              <div
                key={player.id || index}
                className="bg-white shadow-lg rounded-lg p-6 flex items-center gap-4 border-l-8 border-purple-400"
              >
                <div className="flex-1">
                  <h2 className="text-xl font-semibold text-purple-800">{player.name || 'Unknown'}</h2>
                  <p className="text-xl font-semibold text-purple-600">Chronos: {player.chronos ?? 0}</p>
                </div>
                <div className="text-3xl font-bold text-purple-700">
                  {index === 0 ? '🥇' : index === 1 ? '🥈' : '🥉'}
                </div>
              </div>
            ))
          )}
        </div>

        {/* 🏆 Top 3 Leaderboard 
        <div className="max-w-3xl mx-auto space-y-6">
          <h2 className="text-2xl font-bold text-purple-700 mb-4 text-center">🏆 Top 3 Leaderboard</h2>
          {topLeaderboard.length === 0 ? (
            <p className="text-center text-gray-500">No leaderboard data yet. Stay tuned!</p>
          ) : (
            topLeaderboard.map((player, index) => (
              <div
                key={player.id || index}
                className="bg-white shadow-lg rounded-lg p-6 flex items-center gap-4 border-l-8 border-yellow-400"
              >
                <div className="flex-1">
                  <h2 className="text-xl font-semibold text-yellow-800">{player.name || 'Unknown'}</h2>
                  <p className="text-xl font-semibold text-yellow-600">Score: {player.score ?? 0}</p>
                </div>
                <div className="text-3xl font-bold text-yellow-700">
                  {index === 0 ? '🥇' : index === 1 ? '🥈' : '🥉'}
                </div>
              </div>
            ))
          )}
        </div>*/}
      </div>
    </>
  );
}
